import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { trackPageView } from '../utils/usageTracker';
import { useAppSelector } from '../redux';
import { useAuthUser } from './AuthWrapper';
import { InvoicePaymentStatuses, selectInvoicePaymentStatus, selectInvoicePaymentTarget } from '../features/InvoicePayment/InvoicePaymentSlice';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { OverdueInvoicesOverview } from '../components/Invoices/OverdueInvoicesOverview';
import { InvoicesTable } from '../components/Invoices/InvoicesTable';
import { GenericLoadingState } from '../components/GenericLoadingState';
import { GenericErrorState } from '../components/GenericErrorState';
import { useInvoicesData } from '../hooks/useInvoicesData';
import { usePollInvoicePaid } from '../hooks/usePollInvoicePaid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InvoicesPage = () => {
  var _pollTarget$paidInvoi, _overdueInvoicesData$;
  const status = useAppSelector(selectInvoicePaymentStatus);
  const target = useAppSelector(selectInvoicePaymentTarget);
  const pollTarget = status === InvoicePaymentStatuses.POLLING ? target : null;
  const isPolling = status === InvoicePaymentStatuses.POLLING;
  const {
    loading: invoicesLoading,
    error: invoicesError,
    data: overdueInvoicesData
  } = useInvoicesData({
    pageLength: 25,
    filterStatuses: ['past_due']
  }, {
    nextFetchPolicy: 'cache-and-network'
  });
  const authUser = useAuthUser();
  const contactFirstName = authUser === null || authUser === void 0 ? void 0 : authUser.firstname;
  useEffect(() => {
    trackPageView('invoices-overview');
  }, []);
  usePollInvoicePaid((_pollTarget$paidInvoi = pollTarget === null || pollTarget === void 0 ? void 0 : pollTarget.paidInvoiceId) !== null && _pollTarget$paidInvoi !== void 0 ? _pollTarget$paidInvoi : null);
  if (invoicesError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "INVOICES_OVERVIEW_LOAD",
      children: /*#__PURE__*/_jsx(MainContentLayout, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoices.title"
        }),
        children: /*#__PURE__*/_jsx(GenericErrorState, {})
      })
    });
  }
  if (invoicesLoading && !overdueInvoicesData) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "INVOICES_OVERVIEW_LOAD",
      children: /*#__PURE__*/_jsx(MainContentLayout, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoices.title"
        }),
        children: /*#__PURE__*/_jsx(GenericLoadingState, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "INVOICES_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsxs(MainContentLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.title"
      }),
      children: [isPolling && /*#__PURE__*/_jsx(LoadingOverlay, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoices.processingPayment"
        }),
        showLabel: true
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "700",
        children: [/*#__PURE__*/_jsx(OverdueInvoicesOverview, {
          contactFirstName: contactFirstName,
          overdueInvoices: (_overdueInvoicesData$ = overdueInvoicesData === null || overdueInvoicesData === void 0 ? void 0 : overdueInvoicesData.results) !== null && _overdueInvoicesData$ !== void 0 ? _overdueInvoicesData$ : []
        }), /*#__PURE__*/_jsx(InvoicesTable, {})]
      })]
    })
  });
};